import { render, staticRenderFns } from "./plantJukiList.vue?vue&type=template&id=53288944&scoped=true&"
import script from "./plantJukiList.vue?vue&type=script&lang=js&"
export * from "./plantJukiList.vue?vue&type=script&lang=js&"
import style0 from "./plantJukiList.vue?vue&type=style&index=0&id=53288944&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53288944",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCard,VSelect,VSimpleTable})
